export default "__VITE_ASSET__BNH4kaap__"